import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const SearchIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <svg xmlns="http://www.w3.org/2000/svg" width="22.517" height="22.443" viewBox="0 0 22.517 22.443">
        <path
          data-name="App Navigation icons-search"
          d="M27.9 27.173a9.614 9.614 0 1 0-7.47 3.463h.081a9.608 9.608 0 0 0 6.152-2.227l4.658 4.665a.871.871 0 0 0 .614.256h.01a.887.887 0 0 0 .62-.255.874.874 0 0 0 .007-1.233zm-7.381 1.708a7.843 7.843 0 1 1 5.547-2.3 7.843 7.843 0 0 1-5.543 2.3z"
          transform="translate(-10.573 -11.088)"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth=".4px"
        />
      </svg>
    </SvgIcon>
  );
});
